export interface IOrdersEffectivenessReasonItemSchema {
    reason: string;
    count: number;
}

export interface IOrdersEffectivenessDestinationItemSchema {
    id: string;
    locationName: string;
    locationCode: string;
    totalArrivals: number;
    onTimeArrivals: number;
    rejectedOrdersCount: number;
    distinctEntitiesCount: number;
    topReasons: IOrdersEffectivenessReasonItemSchema[];
}

export interface IOrdersEffectivenessEntityItemSchema {
    id: string;
    entityName: string;
    contact: string;
    ordersCount: number;
    onTimeArrivalsCount: number;
    totalArrivalsCount: number;
    topReasons: IOrdersEffectivenessReasonItemSchema[];
}

export interface IOrdersEffectivenessDrilldownSchema {
    topDestinationsWithRejections?: IOrdersEffectivenessDestinationItemSchema[];
    topEntitiesWithRejections?: IOrdersEffectivenessEntityItemSchema[];
    topEntitiesWithPartialDeliveries?: IOrdersEffectivenessEntityItemSchema[];
    rejectionReasons?: IOrdersEffectivenessReasonItemSchema[];
    partialDeliveryReasons?: IOrdersEffectivenessReasonItemSchema[];
}
